export const clearStorage = () => sessionStorage.clear();

export const TEST_NAV_STORAGE_KEY = "tests_nav_state";

export const getItemFromStorage = key => {
  if (!sessionStorage) return undefined;

  try {
    return JSON.parse(sessionStorage.getItem(key));
  } catch (err) {
    // eslint-disable-next-line
    console.error(`Error getting item ${key} from sessionStoragee`, err);
    return undefined;
  }
};

export const storeItem = (key, item) => {
  if (!sessionStorage) return;

  try {
    sessionStorage.setItem(key, JSON.stringify(item));
  } catch (err) {
    // eslint-disable-next-line
    console.error(`Error storing item ${key} to sessionStoragee`, err);
  }
};

export const removeItemFromStorage = key => {
  if (!sessionStorage) return;

  try {
    sessionStorage.removeItem(key);
  } catch (err) {
    // eslint-disable-next-line
    console.error(`Error removing item ${key} from sessionStoragee`, err);
  }
};

export const setTokens = data => {
  if (data) {
    localStorage.setItem('tokens', JSON.stringify(data));
  }
};

export const setUser = user => {
  // eslint-disable-next-line
  user.logged_in = true;
  localStorage.setItem('user', JSON.stringify(user));
};

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user'));
  } catch (e) {
    return null;
  }
};

export const getTokens = () => {
  const emptyRes = { access_token: '', refresh_token: '' };
  const res = JSON.parse(localStorage.getItem('tokens'));
  return res || emptyRes;
};

export const clearLocalStorage = () => {
  localStorage.clear();
  localStorage.setItem('user', JSON.stringify({ logged_in: false, roles: [] }));
};

export const clearSessionStorage = () => {
  sessionStorage.clear();
};

export const setInventoryVarianceLogin = data => {
  localStorage.setItem('inventoryVariance_login', data);
};

export const getUserData = () => {
  let user = getUser();
  if (!user) {
    user = { logged_in: false, roles: [] };
    storeItem('user', user);
  }
  return user;
};

export const getLocalStorageValue = (storageKey) => {
  const state = localStorage.getItem(storageKey) ?? null;
  return state ? JSON.parse(state) : null;
}

export const saveToLocalStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const removeFromLocalStorage = key => {
  localStorage.removeItem(key);
};
